import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useToast
} from '@chakra-ui/react'
import { useState } from 'react'

import { UserService } from '../../../services/User/UserService'

export interface IUserRestrictDialogProps {
  isOpen: boolean
  onClose: () => void
  user: any
  restrict: boolean
  leastDestructiveRef: any
}

export function UserRestrictDialog({ isOpen, onClose, user, restrict, leastDestructiveRef }: IUserRestrictDialogProps) {
  const userService = new UserService()
  const [isLoading, setIsLoading] = useState(false)
  const toast = useToast()

  const handleDelete = async () => {
    setIsLoading(true)
    try {
      if (restrict) {
        await userService.restrict(user.id)
      } else {
        await userService.unrestrict(user.id)
      }

      toast({
        title: 'Acesso atualizado',
        description: 'Acesso atualizado com sucesso.',
        status: 'success',
        duration: 5000,
        isClosable: true
      })

      onClose()
    } catch (error) {
      toast({
        title: 'Erro ao alterar acesso',
        description: 'Erro ao alterar acesso, tente novamente mais tarde.',
        status: 'error',
        duration: 5000,
        isClosable: true
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <AlertDialog leastDestructiveRef={leastDestructiveRef} isOpen={isOpen} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {restrict ? 'Restringir acesso' : 'Liberar acesso'}
          </AlertDialogHeader>

          <AlertDialogBody>Tem certeza que deseja fazer isso?</AlertDialogBody>

          <AlertDialogFooter>
            <Button onClick={onClose} variant="outline">
              Cancelar
            </Button>
            <Button colorScheme="abraGreen" onClick={handleDelete} ml={3} isLoading={isLoading}>
              Sim
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
